export enum ActionType {
    MI2_MAIN__RELOAD = 'MI2_MAIN__RELOAD',
    MI2_MAIN__RELOAD_RESULT = 'MI2_MAIN__RELOAD_RESULT',
    MI2_MAIN__SORT_ROWS = 'MI2_MAIN__SORT_ROWS',
    MI2_MAIN__TOGGLE_FILTER_CATEGORY = 'MI2_MAIN__TOGGLE_FILTER_CATEGORY',
    MI2_MAIN__TOGGLE_FILTER_GROUP = 'MI2_MAIN__TOGGLE_FILTER_GROUP',
    MI2_MAIN__APPLY_FILTER_SELECTION = 'MI2_MAIN__APPLY_FILTER_SELECTION',
    MI2_MAIN__TOGGLE_FILTER_BUTTON = 'MI2_MAIN__TOGGLE_FILTER_BUTTON',
    MI2_MAIN__SHOW_POPULATION_GROUP_DIALOG = 'MI2_MAIN__SHOW_POPULATION_GROUP_DIALOG',
    MI2_MAIN__HIDE_POPULATION_GROUP_DIALOG = 'MI2_MAIN__HIDE_POPULATION_GROUP_DIALOG',
    MI2_MAIN__SHOW_TREND_DIALOG = 'MI2_MAIN__SHOW_TREND_DIALOG',
    MI2_MAIN__SHOW_TREND_DIALOG_RESULT = 'MI2_MAIN__SHOW_TREND_DIALOG_RESULT',
    MI2_MAIN__HIDE_TREND_DIALOG = 'MI2_MAIN__HIDE_TREND_DIALOG',
}
